<template>
  <main>
    <Hero/>
    <ContentWithImage class="hr-complete" sectionName="hr-complete" text-size="sm" justify-center image-order="1" image-order-md="0" :demo="true"/>
    <h2 class="h1 text-center" v-html="$t(`products.Complete.brand-title`)" />
    <b-row class="company-logos">
      <b-col align="center" cols="3"><img width="160px" src="@/assets/complete/logo-pvh.png"/></b-col>
      <b-col align="center" cols="3"><img width="160px" src="@/assets/complete/logo-calvin-klein.png"/></b-col>
      <b-col align="center" cols="3"><img width="160px" src="@/assets/complete/logo-speedo.png"/></b-col>
      <b-col align="center" cols="3"><img width="160px" src="@/assets/complete/logo-vancouver-island.png"/></b-col>
      <b-col align="center" cols="3"><img width="160px" src="@/assets/complete/logo-morrision-hershfield.png"/></b-col>
      <b-col align="center" cols="3"><img width="160px" src="@/assets/complete/logo-tommy-hilifiger.png"/></b-col>
      <b-col align="center" cols="3"><img width="160px" src="@/assets/complete/logo-lube.png"/></b-col>
      <b-col align="center" cols="3"><img width="160px" src="@/assets/complete/logo-keg.png"/></b-col>
    </b-row>
    <Awards/>
    <RequestDemo/>
    <Tools/>
    <LetsGet/>
  </main>
</template>

<script>
import { Hero, Tools, LetsGet, ContentWithImage, RequestDemo, Awards } from '@/components/ui/products'

export default {
  name: 'Complete',
  components: { Hero, Tools, LetsGet, ContentWithImage, RequestDemo, Awards }
}
</script>

<style lang="sass">
.hr-complete
  img
    width: 500px!important
    +media-breakpoint-down(sm)
      width: 80%!important
</style>

<style lang="sass" scoped>
.company-logos
  margin: -10px 0
  padding-top: 80px
  +media-breakpoint-down(sm)
    padding-top: 50px
  +media-breakpoint-down(xs)
    padding-top: 30px

  img
    margin: 10px 0
    max-width: 100%
</style>



// WEBPACK FOOTER //
// src/components/products/Complete/Complete.vue